import React, { useState } from 'react';
import { Link, useNavigate, useSearchParams } from 'react-router-dom';
import { authAPI, formatApiErrorDetail } from '../api';

export const ResetPasswordPage = () => {
  const [searchParams] = useSearchParams();
  const token = searchParams.get('token') || '';
  const navigate = useNavigate();
  const [pwd, setPwd] = useState('');
  const [confirm, setConfirm] = useState('');
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState('');
  const [done, setDone] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    setError('');
    if (pwd !== confirm) { setError('Passwords do not match'); return; }
    setLoading(true);
    try {
      await authAPI.resetPassword(token, pwd, confirm);
      setDone(true);
      setTimeout(() => navigate('/login'), 2000);
    } catch (err) {
      setError(formatApiErrorDetail(err.response?.data?.detail) || err.message);
    } finally { setLoading(false); }
  };

  return (
    <div className="min-h-screen flex items-center justify-center bg-gradient-to-br from-slate-50 to-slate-100 dark:from-[#0B0F19] dark:to-[#131A2B] p-4">
      <div className="w-full max-w-md">
        <div className="clay-card p-8" data-testid="reset-password-page">
          <h1 className="text-3xl font-outfit font-semibold text-primary mb-6">Set New Password</h1>
          {!token ? (
            <div className="text-sm text-red-600">Missing or invalid reset token. <Link to="/forgot-password" className="text-primary underline">Request a new link</Link>.</div>
          ) : done ? (
            <div className="bg-green-50 dark:bg-green-900/20 border border-green-200 text-green-700 px-4 py-3 rounded-lg text-sm" data-testid="reset-success">
              Password reset successfully. Redirecting to login…
            </div>
          ) : (
            <form onSubmit={submit} className="space-y-4">
              {error && <div className="bg-red-50 dark:bg-red-900/20 border border-red-200 text-red-700 px-4 py-3 rounded-lg text-sm">{error}</div>}
              <div>
                <label className="block text-sm font-medium mb-2">New Password</label>
                <input type="password" value={pwd} onChange={(e) => setPwd(e.target.value)} data-testid="reset-new-password"
                  className="w-full px-4 py-3 border border-slate-200 dark:border-slate-700 rounded-lg bg-white dark:bg-slate-900" required minLength={6} />
              </div>
              <div>
                <label className="block text-sm font-medium mb-2">Confirm Password</label>
                <input type="password" value={confirm} onChange={(e) => setConfirm(e.target.value)} data-testid="reset-confirm-password"
                  className="w-full px-4 py-3 border border-slate-200 dark:border-slate-700 rounded-lg bg-white dark:bg-slate-900" required minLength={6} />
              </div>
              <button type="submit" disabled={loading} data-testid="reset-submit"
                className="w-full bg-primary hover:bg-primary/90 text-white font-medium py-3 rounded-lg disabled:opacity-50">
                {loading ? 'Resetting...' : 'Reset Password'}
              </button>
            </form>
          )}
        </div>
      </div>
    </div>
  );
};
export default ResetPasswordPage;
